"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HelpModal = void 0;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@cian/ui-kit");
var _HelpModal = _interopRequireDefault(require("./HelpModal.css"));
var _icons = require("@cian/ui-kit-design-tokens/icons");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const HelpModal = props => {
  const {
    slides,
    onClose
  } = props;
  const content = /*#__PURE__*/React.createElement("div", {
    className: _HelpModal.default['wrapper']
  }, slides.map((slide, index) => {
    const {
      imageUrl,
      title,
      description
    } = slide;
    return /*#__PURE__*/React.createElement("div", {
      key: index
    }, imageUrl && /*#__PURE__*/React.createElement("img", {
      src: imageUrl,
      alt: "",
      className: _HelpModal.default['image']
    }), title && /*#__PURE__*/React.createElement("div", {
      className: _HelpModal.default['title']
    }, /*#__PURE__*/React.createElement(_uiKit.UIHeading1, null, title)), description && /*#__PURE__*/React.createElement(_uiKit.UIText1, {
      whiteSpace: "pre-wrap"
    }, description));
  }));
  return /*#__PURE__*/React.createElement(_uiKit.Modal, {
    open: true,
    onOpenChange: onClose,
    header: /*#__PURE__*/React.createElement(_uiKit.ModalTitle, null, "\u041A\u0430\u043A\u0438\u0435 \u0431\u044B\u0432\u0430\u044E\u0442 \u0441\u043F\u043E\u0441\u043E\u0431\u044B \u043F\u043E\u043A\u0443\u043F\u043A\u0438"),
    body: content,
    closeButtonProps: {
      theme: 'fill_light',
      icon: /*#__PURE__*/React.createElement(_icons.IconActionClose16, {
        color: "current_color"
      }),
      title: 'Закрыть'
    },
    footer: /*#__PURE__*/React.createElement(_uiKit.ModalClose, {
      asChild: true
    }, /*#__PURE__*/React.createElement("div", {
      className: _HelpModal.default['actions']
    }, /*#__PURE__*/React.createElement(_uiKit.Button, null, "\u0411\u0443\u0434\u0443 \u0437\u043D\u0430\u0442\u044C")))
  });
};
exports.HelpModal = HelpModal;